import { useContext } from 'react';
import { resultsInterface } from '../../lib/type';
import './Results.scss';
import { layoutContext } from '../Context/RoiCalculator';

const Results = (resultsProps: { contents: resultsInterface }) => {
  const { contents } = resultsProps;
  const { output } = useContext(layoutContext);

  return (
    <div className="bx--grid roi-calculator__results">
      <div className="bx--row">
        <div className="bx--col-lg-10 bx--col-md-6 bx--col-sm-4 roi-calculator__results-content">
          <h2 className="roi-calculator__results-title">
            {contents.resultsTitle}*
          </h2>
          <h4 className="roi-calculator__results-subtitle">
            {contents.resultsText}
          </h4>
          <div className="bx--row roi-calculator__results-output">
            <div className="bx--col-lg-8 bx--col-md-4 roi-calculator__results-output-texts">
              <p className="roi-calculator__results-output-text">
                {contents.reduceVolume}
              </p>
              <p className="roi-calculator__results-output-text">
                {contents.reduceHandle}
              </p>
              <p className="roi-calculator__results-output-text">
                {contents.reduceAdmin}
              </p>
              <p className="roi-calculator__results-output-text-final">
                {contents.savings}
              </p>
            </div>
            <div className="bx--col-lg-8 bx--col-md-4 roi-calculator__results-output-numbers">
              <p className="roi-calculator__results-output-number">{`USD $ ${output.reduceOperationalCostLow.toLocaleString()} – ${output.reduceOperationalCostHigh.toLocaleString()}`}</p>
              <p className="roi-calculator__results-output-number">{`USD $ ${output.reduceHandleTimesLow.toLocaleString()} – ${output.reduceHandleTimesHigh.toLocaleString()}`}</p>
              <p className="roi-calculator__results-output-number">{`USD $ ${output.increaseProductivityLow.toLocaleString()} – ${output.increaseProductivityHigh.toLocaleString()}`}</p>
              <p className="roi-calculator__results-output-number-final">
                {`USD $ ${output.totalAnnualSavingsLow.toLocaleString()} - ${output.totalAnnualSavingsHigh.toLocaleString()}`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Results;
